import { render, staticRenderFns } from "./BundlePriceRule.vue?vue&type=template&id=60338a91&scoped=true"
import script from "./BundlePriceRule.vue?vue&type=script&setup=true&lang=ts"
export * from "./BundlePriceRule.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BundlePriceRule.vue?vue&type=style&index=0&id=60338a91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60338a91",
  null
  
)

export default component.exports